import { ShipmentFilterName } from '../constants';

export class ShipmentFiltersLoad {
  public static readonly type = '[ShipmentFilters] Load';
}

export class ShipmentFiltersUpdate {
  public static readonly type = '[ShipmentFilters] Update';
  constructor(public payload: ShipmentFilterName[]) {}
}

export class ShipmentFiltersInitialState {
  public static readonly type = '[ShipmentFilters] Set Initial State';
}
